/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {message} from "antd";
import request from "./request";
import {getInfoFromLocalStorage, removeInfoFromLocalStorage, setInfoToLocalStorage} from "../actions";
import {setIconFont} from "../view/components/svgIcon/IconFont";

/**
 * 登录后系统的提供的基本信息,注意，是登录之后才能拿到的基本信息
 * 当前用户信息
 * 当前系统所有配置信息
 */
export default class SystemBaseInfoComponent extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
    }

    loadStart(){
        setInfoToLocalStorage("systemLoad","start");
    }

    loadEnd(){
        setInfoToLocalStorage("systemLoad","end");
    }

    infoIsLoadOver(){
        return getInfoFromLocalStorage("systemLoad") === "end";
    }

    /**
     * @returns {{
     *     currentUser,  当前用户
     *     config,       系统参数配置
     *     permissions   当前用户的权限
     *     permissionsUserAccount,
     * }}
     */
    getInfo() {
        let error = (msg)=>{
            //message.error(msg);
            console.error(msg);
            trace();
            throw new Error(msg);
        };
        let keys = [
            {key:"Token",dec:"用户token令牌获取失败"},
            {key:"currentUser",dec:"用户信息获取失败"},
            {key:"config",dec:"系统配置信息获取失败",exec:(data)=>{
                let sysConfig = {
                    all: data,
                    getConfigByKey: (key)=>{
                        for(let i = 0; data && i < data.length; i++){
                            let item = data[i];
                            if(key === item.configKey&&item.isEnable==1){
                                return item;
                            }
                        }
                        return {};
                    },
                    getValueByKey: (key, defaultValue='')=>{
                        for(let i = 0; data && i < data.length; i++){
                            let item = data[i];
                            if(key === item.configKey&&item.isEnable==1){
                                return item.configValue?item.configValue:defaultValue;
                            }
                        }
                        return defaultValue;
                    }
                };
                window.sysConfig = sysConfig;
                setIconFont();
                return sysConfig;
            }},
            {key:"permissionsUserAccount",dec:"权限信息获取失败"},
            {key:"permissions",dec:"权限信息获取失败"},
        ];
        let info = {};
        keys.map(({key, dec, exec})=>{
            let value = getInfoFromLocalStorage(key);
            if(!value){
                error(dec);
            }
            if(exec){
                value = exec(value);
            }
            return info[key] = value;
        });
        return info;
    }

    removeInfo(){
        //删除历史基本信息及token
        sessionStorage.clear();
    }

    refreshConfig(fun){
        let url = `/cm-sites-sys/config/all`;
        let errorCallBack = (e)=>{
            console.error("系统参数配置刷新失败", e);
            message.error("系统参数配置刷新失败！")
        };
        let callBack = (data)=>{
            setInfoToLocalStorage("config", data);
            fun && fun();
        };
        request({url, callBack, message:{info:errorCallBack, error:errorCallBack}});
    }

}

const trace = (count)=>{
    if(window.arguments){
        let caller = window.arguments.callee.caller;
        let i = 0;
        count = count || 10;
        while (caller && i < count) {
            console.error(caller.toString());
            caller = caller.caller;
            i++;
        }
    }
};